import { useId, useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { PasswordInput } from '@/components/PasswordInput';
import { describeAuthError, useSignIn } from '@liniya/client-core';

export function LoginPage() {
  const emailId = useId();
  const signIn = useSignIn();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (signIn.isPending) return;
    signIn.mutate({ email: email.trim(), password });
  };

  return (
    <main className="auth-screen">
      <div className="auth-card">
        <header>
          <span className="line-logo" aria-hidden="true">
            <i />
          </span>
          <h1>Вход в «Линию»</h1>
          <p>Защищённые сообщения, звонки и файлы.</p>
        </header>

        <form className="auth-form" onSubmit={submit} noValidate>
          {signIn.isError ? (
            <p className="auth-alert" role="alert">
              {describeAuthError(signIn.error)}
            </p>
          ) : null}

          <div className="field">
            <label htmlFor={emailId}>Email</label>
            <input
              id={emailId}
              className="input"
              type="email"
              inputMode="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              disabled={signIn.isPending}
            />
          </div>

          <PasswordInput
            label="Пароль"
            value={password}
            onChange={setPassword}
            disabled={signIn.isPending}
          />

          <button
            className="primary-btn"
            type="submit"
            disabled={signIn.isPending || !email.trim() || !password}
          >
            {signIn.isPending ? <span className="spinner" aria-hidden="true" /> : null}
            {signIn.isPending ? 'Входим…' : 'Войти'}
          </button>
        </form>

        <p className="auth-switch">
          Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
        </p>
        <p className="auth-switch">
          <a href="/password/reset/">Забыли пароль?</a>
        </p>
        {/* The same link the app carries, for the same reason: this is the
            moment somebody decides to hand over an address. */}
        <p className="auth-legal">
          <a href="/privacy/">Политика конфиденциальности</a>
        </p>
      </div>
    </main>
  );
}
